import {Interceptor} from '@jobseeker/common-core/components/Inteceptor';
import {NavLayout, ResponsiveLayout, SeoLayout} from '@layouts';
import {getConfigByApp, utilServerSideDeviceDetection} from '@utils';
import {metaInfo} from '@configs';
import {HOME, PRIVACY} from '@constants';
import loadSEO from '@helpers/loadSEO';
import {getSearchBarVariant} from '@helpers';
import {wrapper} from '@jobseeker/common-core/stores';
import {VersionVariants} from '@jobseeker/lotus/enums/variants';
import PrivacyPolicyPage from '@components/Static/Privacy';
import {shallowEqual, useDispatch, useSelector} from 'react-redux';
import useValidateAuth from '@jobseeker/common-core/hooks/useValidateAuth';
import {TrackEventUBA} from '@jobseeker/common-core/utils';
import {useRouter} from 'next/router';
import {useEffect} from 'react';
import dynamic from 'next/dynamic';
import {InjectSearchOverlay} from '@components';
import {AppState} from '@jobseeker/common-core/types';
import {isCSR} from '@jobseeker/lotus/utils';
import type {GetServerSidePropsContext} from 'next/types';
// import Badge from '@components/Notification/Badge';

const HiristAuthentication = dynamic(
  () =>
    import(
      '@jobseeker/client-harness/components/HiristAuthenticationHarness/AuthForm'
    ),
  {
    ssr: false,
  }
);
const isAppIimjobs = process.env.NEXT_PUBLIC_APP_NAME === 'iimjobs';

type PrivacyProps = {
  seoConfig: object;
  isMobile?: boolean;
};

const Privacy = ({seoConfig, isMobile}: PrivacyProps) => {
  const metaData = getConfigByApp(metaInfo, HOME, true, PRIVACY);

  const dispatch =
    /* eslint-disable @typescript-eslint/no-explicit-any */ useDispatch<any>();

  useValidateAuth(dispatch);

  const {searchOverlay, enableLoginPopup} = useSelector(
    (state: AppState) => state.app.layout,
    shallowEqual
  );
  const isSearchEnabled = useSelector(() => searchOverlay, shallowEqual);
  const router = useRouter();
  useEffect(() => {
    TrackEventUBA('privacyPageView', 'view', {
      ref: router.query.ref || '',
      pageName: 'Privacy Page',
      sessionUsername: `${sessionStorage.getItem('userId')}`,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onLoginSuccess = () => {
    if (isCSR()) {
      window.location.reload();
    }
  };
  const breadcrumbElements = isAppIimjobs
    ? [
        {
          name: 'Home',
          item: '/',
        },
        {
          name: 'Privacy Policy',
          item: '',
        },
      ]
    : [];

  return (
    <Interceptor metaInfo={metaData}>
      <SeoLayout seoConfig={seoConfig} />
      <NavLayout>
        <ResponsiveLayout
          breadcrumbElements={breadcrumbElements}
          variant={VersionVariants.VERSION_TWO}
        >
          {!isAppIimjobs && (
            <HiristAuthentication
              variant={VersionVariants.VERSION_TWO}
              onSuccess={onLoginSuccess}
              openDialog={enableLoginPopup}
              setOpenDialog={() => {
                dispatch({
                  type: 'AppContext/set_login_popup',
                  payload: false,
                });
              }}
            />
          )}
          <InjectSearchOverlay isSearchEnabled={isSearchEnabled} />
          <PrivacyPolicyPage isMobile={isMobile} />
        </ResponsiveLayout>
      </NavLayout>
    </Interceptor>
  );
};

export const getServerSideProps = wrapper.getServerSideProps(
  store => async (context: GetServerSidePropsContext) => {
    const searchBarVariant = await getSearchBarVariant({req: context.req});
    store.dispatch({
      type: 'AppContext/set_ab_variants',
      payload: {searchBar: searchBarVariant},
    });
    const seoConfig = await loadSEO(PRIVACY);
    const {isMobile} = utilServerSideDeviceDetection(context);

    store.dispatch({
      type: 'AppContext/set_current_page',
      payload: {page: PRIVACY},
    });

    return {
      props: {
        seoConfig,
        isMobile,
      },
    };
  }
);

export default Privacy;
